import { authenticatedHttp } from "@/lib/services/authenticated-http";

/** Upload a single file via the backend proxy and return its public S3 URL. */
export const uploadEmailAttachment = async (file: File): Promise<string> => {
  const formData = new FormData();
  formData.append("file", file);
  // Clear Content-Type so axios auto-sets multipart/form-data with the correct boundary.
  // The instance default of "application/json" would otherwise prevent the server parsing the file.
  const response = await authenticatedHttp.post("/files/upload-attachment", formData, {
    headers: { "Content-Type": undefined },
  });
  return response.data.fileUrl;
};

/** Upload multiple files concurrently and return their public URLs. */
export const uploadEmailAttachments = async (files: File[]): Promise<string[]> => {
  return Promise.all(files.map(uploadEmailAttachment));
};
